import { AddressFormValues } from '../forms/address.form';
import { AddressFormPickedAddressModel } from '../models/address-form-picked-address.model';
import { addressFormToDataAddressAdapter } from './address-form-to-data-address.adapter';
import { dataAddressToAddressLinesAdapter } from './data-address-to-address-lines.adapter';

export const addressFormToAddressDataModelAdapter = (formAddressData: AddressFormValues | null): AddressFormPickedAddressModel | null => {
  if (formAddressData === null) return null;

  if (formAddressData.isManual) return handleManualAddress(formAddressData);
  return handlePickedAddress(formAddressData.pickedAddress);
};

const handlePickedAddress = (pickedAddress: AddressFormPickedAddressModel | string | null): AddressFormPickedAddressModel | null => {
  if (!pickedAddress || typeof pickedAddress == 'string') return null;
  return pickedAddress;
};

const handleManualAddress = (formAddressData: AddressFormValues): AddressFormPickedAddressModel | null => {
  const dataAddress = addressFormToDataAddressAdapter(formAddressData);
  const addressLines = dataAddressToAddressLinesAdapter(dataAddress);

  return {
    addressLines,
    address: dataAddress,
    coordinates: undefined,
    details: undefined,
  };
};
